import React from "react";
import NotFound from "../../components/NotFound/NotFound";

export default function NotFound404() {
  return <NotFound />;
}
